import { useContext, useEffect } from 'react';
import { ShortcutContext } from 'Context/Shortcut';

// Declarative building block: register any combo you want ("mod+s",
// "mod+ArrowRight", "Escape", ...), Mac/Win/Linux-compatible by
// construction (see utils/platform). `scope` defaults to the always-on
// 'global' scope; pass a scope id obtained from useShortcutScope to bind
// it to a specific modal/drawer instead. `description` is optional and
// purely for display: pass it to have this shortcut show up in the
// keyboard shortcuts help panel (mod+/); omit it for internal/one-off
// bindings you don't want listed there.
const useShortcut = (combo, handler, { scope = 'global', enabled = true, description } = {}) => {
  const shortcutContext = useContext(ShortcutContext);

  useEffect(() => {
    if (!enabled || !shortcutContext) return undefined;

    return shortcutContext.registerHandler(scope, combo, handler, description);
  }, [shortcutContext, scope, combo, handler, enabled, description]);
};

export default useShortcut;
